import { render } from "./ImagePublic.vue?vue&type=template&id=6bcd72d3"
import script from "./ImagePublic.vue?vue&type=script&lang=js"
export * from "./ImagePublic.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__